
import Vue from 'vue'
import { get } from 'lodash-es'
import { EProjectStatus, EWorkModelType } from '@/helpers/enums'

Vue.filter('trimDescription', (fullText, query) => {
  const getRandomIntInclusive = (min, max) => {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const allowedLength = 250
  const startPosition = fullText.toLowerCase().indexOf(query.toLowerCase())
  let cutText = fullText

  if (fullText.length > allowedLength) {
    if (startPosition > allowedLength / 2) {
      cutText = `[...]${fullText.substring(
        getRandomIntInclusive(startPosition - 125, startPosition),
        fullText.length
      )}`
    }

    return `${cutText.substring(0, 250)}[...]`
  }
  return cutText
})

Vue.filter('highlightTitle', function (fullText, query) {
  const check = new RegExp(query, 'ig')

  return fullText.toString().replace(check, (matchedText) => {
    return `<strong class="warning--text">${matchedText}</strong>`
  })
})

export default {
  name: 'CardContent',

  props: {
    descriptionShow: Boolean,
    item: {
      type: Object,
      required: true
    },
    applicationStatus: {
      type: String,
      required: false,
      default: ''
    },
    isAppliedByMsp: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      exposeAll: false,
      poolsCount: Number
    }
  },

  computed: {
    assignmentDuration() {
      const { assignmentDuration } = this.item
      const duration = this.$moment.duration({ days: assignmentDuration })

      return assignmentDuration > 29
        ? this.$t('talent.project.search.time.for.months', {
            duration: Math.round(duration.as('months'))
          })
        : this.$t('talent.project.search.time.for.days', {
            duration: Math.round(duration.as('days'))
          })
    },

    hoursPerWeek() {
      return this.$t('talent.project.search.hours.week', {
        time: this.item.hoursPerWeek
      })
    },

    jobFieldSettings() {
      return this.$useLeConfig(this.item.legalEntityName, this.$ELeConfig.JOB_FIELD_SETTINGS)
    },

    isClosedForNewCandidates() {
      return this.item.status !== EProjectStatus.ACTIVE
    },

    isHoursPerWeekVisible() {
      return this.isJobFieldVisible('hoursPerWeek')
    },
    isPayRateVisible() {
      return this.isJobFieldVisible('payRateRange')
    },
    isLocationVisible() {
      return this.isJobFieldVisible('location')
    },
    poolCounter() {
      if (this.$route.query?.pools) {
        return `+${this.item?.affectedPools?.totalResults - this.filteredPools().length}`
      } else {
        return `+${this.item?.affectedPools?.totalResults - 1}`
      }
    },

    longestWordinTitle() {
      return this.findLongestWord(this.showTitle(this.item.title))
    },

    makeTitleFontSmallerOnMobile() {
      return this.longestWordinTitle > 20 && this.$vuetify.breakpoint.name === 'xs'
    },

    publishedAt() {
      const time = this.$moment(this.item.publishDate).fromNow()
      return this.$t('talent.project.search.published.at', { time })
    },

    logoPath() {
      return this.$legalEntityLogo(this.item.legalEntityName, {
        width: 48,
        height: 48,
        fit: 'cover'
      })
    }
  },

  methods: {
    rateSafetyCheck(item, type) {
      return item?.rateRange?.[type]
    },

    showTitle(value) {
      if (this.$route.query?.any) {
        const decodedUrlQuery = decodeURIComponent(this.$route.query.any)
        return this.$options.filters.highlightTitle(value, decodedUrlQuery)
      } else {
        return value?.length > 250 ? this.$truncate(value, 250) : value
      }
    },

    findLongestWord(str) {
      const longestWord = str
        .toString()
        .split(' ')
        .reduce(function (longest, currentWord) {
          return currentWord.length > longest.length ? currentWord : longest
        }, '')
      return longestWord.length
    },

    showDescription(value) {
      if (this.$route.query?.any) {
        const decodedUrlQuery = decodeURIComponent(this.$route.query.any)
        const trimmedText = this.$options.filters.trimDescription(value, decodedUrlQuery)

        return this.$options.filters.highlightTitle(trimmedText, decodedUrlQuery)
      } else {
        return this.$truncate(value, 250)
      }
    },

    filteredPools() {
      const poolsList = this.item.affectedPools

      if (poolsList.totalResults >= 1) {
        return poolsList.results.filter((o1) => this.$route.query?.pools.includes(o1.id))
      }
    },

    expandPools() {
      return this.item.affectedPools?.results.filter(
        (o1) => !this.$route.query?.pools?.includes(o1.id)
      )
    },

    location(item) {
      const city = item.siteCity
      let flag

      if (item.workModelType === EWorkModelType.REMOTE) {
        flag = `(${this.$capitalize(
          this.$t('talent.project.search.label.work.preference.remote')
        )})`
      } else if (item.workModelType === EWorkModelType.HYBRID) {
        flag = `(${this.$capitalize(
          this.$t('talent.project.search.label.work.preference.hybrid')
        )})`
      }

      return [city, flag].filter(Boolean).join(' ')
    },

    isJobFieldVisible(field) {
      return get(this.jobFieldSettings, field, 'show') === 'show'
    }
  }
}
